module.exports = __webpack_public_path__ + "static/media/designer-opening-sixshots.0b91397a.jpeg";